import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import {
  formatCollaborator,
  processCollaboratorResponse,
} from './utils';

const COLLABORATOR_URL = `${API_CONFIG.API}/node/collaborator`;

export default {
  saveCollaborator(collaborator) {
    return base.http().post(`${COLLABORATOR_URL}`, formatCollaborator(collaborator));
  },
  updateCollaborator(collaborator) {
    return base.http().patch(`${COLLABORATOR_URL}/${collaborator.id}`, formatCollaborator(collaborator));
  },
  getAllCollaborators() {
    return base.http().get(`${COLLABORATOR_URL}`)
      .then(res => processCollaboratorResponse(res));
  },
};



// WEBPACK FOOTER //
// ./src/features/colaborador/service.js